/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import * as styled from 'styled-components';
import {theme} from 'components/shared/theme';

const {spacing, colors, fontSizeS} = theme;

export const Label = styled.default.label<{color?: string}>`
  font-size: ${fontSizeS};
  color: ${({color}) => (color || colors.gray900)};
  font-weight: bold;
  margin: ${spacing.xxSmall} 0;
  display: block;
`;